/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IndividualInvestor {
  readonly first_name: string;
  readonly last_name: string;
  readonly email: string;
  readonly dob: string;
  readonly pnr: string;
  readonly d_number: string;
  readonly utl: string;
  readonly address: string;
  readonly city: string;
  readonly post_code: string;
  readonly country: string;
  readonly amount: number;
  readonly phone_number: string | null;
}
